import { Dispatch } from 'redux';

import { setCookie } from 'ha/modules/Cookies';
import CookiesConstants from 'ha/constants/Cookies';

import { homeToGoDomain } from '../constants';

interface Query {
  utm_source?: string;
  utm_term?: string;
}

export default ({ utm_source, utm_term }: Query) => (dispatch: Dispatch) => {
  if (utm_source === homeToGoDomain && utm_term) {
    dispatch(
      setCookie(CookiesConstants.HOME_TO_GO_UTM, utm_term, {
        expires: 30,
      }),
    );
  }
};
